import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import createStore from '../../../../plugins/utils/createStore';
import { NoteIcon } from '../../../Icons';
import ColumnTypes from '../../types/ColumnTypes';
import mapCollectionKeys from '../../utils/mapCollectionKeys';
import Field from './Field';
import Note from '../../components/Note';
var KEY_MAPPING = {
  objectID: 'id'
};

var makeNotesPlugin = function makeNotesPlugin() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$fetchNotes = _ref.fetchNotes,
      fetchNotes = _ref$fetchNotes === void 0 ? function (query) {
    return [];
  } : _ref$fetchNotes;

  return function (_ref2) {
    var isPublic = _ref2.isPublic,
        _ref2$decorator = _ref2.decorator,
        decorator = _ref2$decorator === void 0 ? function (x) {
      return x;
    } : _ref2$decorator;
    var store = createStore();
    var NoteLinkComponent = decorator(Note);
    return [{
      queries: {
        getFieldNotes: function getFieldNotes(database, recordKey, columnKey) {
          var _database$getFieldDat = database.getFieldData(recordKey, columnKey),
              notes = _database$getFieldDat.notes;

          return notes || [];
        },
        getNotesFromQuery: function getNotesFromQuery(database, recordKey, columnKey) {
          var query = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
          var currentNotes = database.getFieldNotes(recordKey, columnKey);
          return fetchNotes(query).then(function (notes) {
            return mapCollectionKeys(notes, KEY_MAPPING).filter(function (note) {
              return !currentNotes.find(function (_ref3) {
                var id = _ref3.id;
                return note.id === id;
              });
            });
          });
        }
      },
      commands: {
        addNoteToField: function addNoteToField(database, recordKey, columnKey, _ref4) {
          var id = _ref4.id,
              title = _ref4.title;
          return database.updateFieldData(recordKey, columnKey, function (_ref5) {
            var _ref5$notes = _ref5.notes,
                notes = _ref5$notes === void 0 ? [] : _ref5$notes,
                data = _objectWithoutProperties(_ref5, ["notes"]);

            return _objectSpread({}, data, {
              notes: [].concat(_toConsumableArray(notes), [{
                id: id,
                title: title
              }])
            });
          });
        },
        removeNoteFromField: function removeNoteFromField(database, recordKey, columnKey, note) {
          return database.updateFieldData(recordKey, columnKey, function (_ref6) {
            var _ref6$notes = _ref6.notes,
                notes = _ref6$notes === void 0 ? [] : _ref6$notes,
                data = _objectWithoutProperties(_ref6, ["notes"]);

            return _objectSpread({}, data, {
              notes: notes.filter(function (_ref7) {
                var id = _ref7.id;
                return id !== note.id;
              })
            });
          });
        }
      },
      getWidth: function getWidth(columnType, database, next) {
        if (ColumnTypes.NOTES === columnType) {
          return 40;
        }

        return next();
      },
      renderColumnIcon: function renderColumnIcon(columnType, database, next) {
        if (ColumnTypes.NOTES === columnType) {
          return React.createElement(NoteIcon, null);
        }

        return next();
      },
      renderColumnType: function renderColumnType(columnType, database, next) {
        if (ColumnTypes.NOTES === columnType) {
          return 'Notes';
        }

        return next();
      },
      canEdit: function canEdit(columnType, database, next) {
        if (ColumnTypes.NOTES === columnType) {
          return true;
        }

        return next();
      },
      onStartTyping: function onStartTyping(event, database, next) {
        var _database$getActive = database.getActive(),
            column = _database$getActive.column,
            record = _database$getActive.record;

        if (ColumnTypes.NOTES !== column.type) {
          return next();
        }

        var fieldKey = database.getFieldKey(record.key, column.key);
        store.updateItem(fieldKey, {
          value: event.key.length === 1 ? event.key : ''
        });
        next();
      },
      renderField: function renderField(props, database, next) {
        if (ColumnTypes.NOTES === props.column.type) {
          return React.createElement(Field, Object.assign({
            NoteLinkComponent: NoteLinkComponent,
            database: database,
            store: store
          }, props));
        }

        return next();
      },
      serializeField: function serializeField(_ref8, database, next) {
        var field = _ref8.field,
            record = _ref8.record,
            column = _ref8.column;
        if (ColumnTypes.NOTES !== column.type) return next();
        return field.data.notes.map(function (note) {
          return note.title;
        }).join(', ');
      }
    }];
  };
};

export default makeNotesPlugin;